import ContentTwoDark from "../components/content/ContentTwoDark";
import WhiteMidCTATwo from "../components/cta/WhiteMidCTATwo";
import FooterOne from "../components/footer/FooterOne";
import { Header } from "../components/header/Header";
import TitleOne from "../components/section-title/TitleOne";

const Crypto = () => {
  return (
    <>
      <div style={{ backgroundColor: "#0c0f19" }}>
        <Header />
      </div>
      <TitleOne />
      <div style={{ backgroundColor: "#0c0f19" }}>
        <ContentTwoDark />
      </div>
      {/* <CTAThree /> */}
      <WhiteMidCTATwo />
      <FooterOne />
    </>
  );
};

export default Crypto;
